<template>
  <div>
    <div class="notice-container">
      <div style="background: #E8F0FF;padding:12px 16px;display: flex;align-items: center;">
        <img src="../../../assets/images/icon_announcement.png" alt="" style="width: 20px;height: 20px;">
        <span style="color: #0E193B;font-size: 14px;margin-left: 8px;">{{ $t('龙翼简报.公告') }}</span>
      </div>

      <kl-empty v-if="noticeList.length == 0" :show-pic="false" />

      <div class="notice-item" v-for="(item, index) in noticeList" :key="index">
        <div @click="handleNoticeClick(item)"
          style="display: flex;align-items: center;cursor: pointer;">
          <img v-if="item.mustRead == 1" src="../../../assets/images/icon_dot_red.png"
            style="width: 20px;height: 20px;" />
          <img v-else src="../../../assets/images/icon_dot_gray.png" style="width: 20px;height: 20px;" />
          <!--长度限制，超出部分省略号-->
          <span class="notice-text">{{ item.afficheTitle }}</span>
        </div>
        <div class="date">{{ formatDate(item.updateTime, 1) }}</div>
      </div>

    </div>
    <div class="notice-container" style="margin-top: 20px;">
      <div style="background: #E8F0FF;padding:12px 16px;display: flex;align-items: center;">
        <img src="../../../assets/images/icon_message.png" alt="" style="width: 20px;height: 20px;">
        <span style="color: #0E193B;font-size: 14px;margin-left: 8px;">{{ $t('龙翼简报.消息') }}</span>
      </div>

      <kl-empty v-if="alarmList.length == 0" :show-pic="false" />

      <div class="notice-item" v-for="(item, index) in alarmList" :key="index">
        <div style="display: flex;align-items: center;cursor: pointer;" @click="handleAlarmClick(item)">
          <img v-if="item.Failrelevel == '4'" src="../../../assets/images/icon_dot_red.png"
            style="width: 20px;height: 20px;" />
          <img v-else src="../../../assets/images/icon_dot_gray.png" style="width: 20px;height: 20px;" />
          <span class="notice-text">{{ item.Failure }}</span>
        </div>
        <div class="date">{{ item.FailureTimec }}</div>
      </div>

    </div>
  </div>
</template>
<script>
export default {
  name: "DashboardNotice",
  props: {
    noticeList: {
      type: Array,
      default: () => []
    },
    alarmList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    formatDate(time, isShort) {
      if (!time) return "";

      time = time.replace("T", " ");
      time = time.replace("Z", "");
      //只显示日期部分
      if (isShort && isShort == 1) {
        //只显示日期部分
        time = time.split(" ")[0];
        return time;
      }
      return time;
    },
    handleNoticeClick(item) {
      this.$emit('notice-click', item);
    },
    handleAlarmClick(item) {
      this.$emit('alarm-click', item);
    }
  }
};
</script>
<style scoped>
.notice-container {
  border: 1px solid #C5D0E2;
  border-radius: 2px;
  background: #FFFFFF;
  padding: 10px;
}

.notice-item {
  margin-bottom: 10px;
  padding: 10px;
  border-bottom: 1px solid #F0F0F0;
}

.notice-item:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

.notice-text {
  flex: 1;
  margin-left: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #333;
}

.date {
  margin-left: 28px;
  margin-top: 4px;
  font-size: 11px;
  color: #999;
}
</style>